import Organization from '__core/shared/model/organization/Organization';
import OrganizationAccess from '__core/shared/model/organization/OrganizationAccess';
import OrganizationDetails from '__core/shared/model/organization/OrganizationDetails';
import OrganizationEnterprise from '__core/shared/model/organization/OrganizationEnterprise';
import OrganizationFeatures from '__core/shared/model/organization/OrganizationFeatures';
import OrganizationIntegrations from '__core/shared/model/organization/OrganizationIntegrations';
import OrganizationPermissions from '__core/shared/model/organization/OrganizationPermissions';
import OrganizationFinancialPositionBuffers from '__core/shared/model/organization/OrganizationFinancialPositionBuffers';
import OrganizationCommissionLimits from '__core/shared/model/organization/OrganizationCommissionLimits';
import OrganizationExchange from '__core/shared/model/organization/OrganizationExchange';
import OrganizationWebHooks from '__core/shared/model/organization/OrganizationWebHooks';
import Subscription from '__core/shared/model/subscription/Subscription';
import organizationController from './organization.controller';
import stOrganizationAdd from './organizationAdd.component';
import organizationBrandingController from './organizationBranding.controller';
import organizationClientPortalController from './organizationClientPortal.controller';
import organizationFeaturesController from './organizationFeatures.controller';
import organizationFinancialPositionBuffersController from './organizationFinancialPositionBuffers.controller';
import organizationCommissionLimitsController from './organizationCommissionLimits.controller';
import organizationGroupsAndBranchesController from './organizationGroupsAndBranches.controller';
import stOrganizationGroupsAndBranchesAdd from './organizationGroupsAndBranchesAdd.component';
import stOrganizationGroupsAndBranchesEdit from './organizationGroupsAndBranchesEdit.component';
import stOrganizationGroupsAndBranchesList from './organizationGroupsAndBranchesList.component';
import stOrganizationGroupsAndBranchesMove from './organizationGroupsAndBranchesMove.component';
import organizationLenderCommissionsController from './organizationLenderCommissions.controller';
import organizationMarketingController from './organizationMarketing.controller';
import organizationPartnerPortalController from './organizationPartnerPortal.controller';
import organizationPermissionsController from './organizationPermissions.controller';
import organizationProfessionalLicensesController from './organizationProfessionalLicenses.controller';
import organizationsController from './organizations.controller';
import stOrganizationsList from './organizationsList.component';
import organizationSuspendedController from './organizationSuspended.controller';
import organizationSwitchController from './organizationSwitch.controller';

export default angular
  .module('st.Organization', ['st.Core', 'angular-cache'])
  .factory('Organization', () => Organization)
  .factory('OrganizationAccess', () => OrganizationAccess)
  .factory('OrganizationDetails', () => OrganizationDetails)
  .factory('OrganizationEnterprise', () => OrganizationEnterprise)
  .factory('OrganizationFeatures', () => OrganizationFeatures)
  .factory('OrganizationIntegrations', () => OrganizationIntegrations)
  .factory('OrganizationPermissions', () => OrganizationPermissions)
  .factory('OrganizationFinancialPositionBuffers', () => OrganizationFinancialPositionBuffers)
  .factory('OrganizationCommissionLimits', () => OrganizationCommissionLimits)
  .factory('OrganizationExchange', () => OrganizationExchange)
  .factory('OrganizationWebHooks', () => OrganizationWebHooks)
  .factory('Subscription', () => Subscription)
  .controller('organizationController', organizationController)
  .component('stOrganizationAdd', stOrganizationAdd)
  .controller('organizationBrandingController', organizationBrandingController)
  .controller('organizationClientPortalController', organizationClientPortalController)
  .controller('organizationFeaturesController', organizationFeaturesController)
  .controller(
    'organizationFinancialPositionBuffersController',
    organizationFinancialPositionBuffersController
  )
  .controller('organizationCommissionLimitsController', organizationCommissionLimitsController)
  .controller(
    'organizationGroupsAndBranchesController',
    organizationGroupsAndBranchesController
  )
  .component('stOrganizationGroupsAndBranchesAdd', stOrganizationGroupsAndBranchesAdd)
  .component('stOrganizationGroupsAndBranchesEdit', stOrganizationGroupsAndBranchesEdit)
  .component('stOrganizationGroupsAndBranchesList', stOrganizationGroupsAndBranchesList)
  .component('stOrganizationGroupsAndBranchesMove', stOrganizationGroupsAndBranchesMove)
  .controller(
    'organizationLenderCommissionsController',
    organizationLenderCommissionsController
  )
  .controller('organizationMarketingController', organizationMarketingController)
  .controller('organizationPartnerPortalController', organizationPartnerPortalController)
  .controller('organizationPermissionsController', organizationPermissionsController)
  .controller(
    'organizationProfessionalLicensesController',
    organizationProfessionalLicensesController
  )
  .controller('organizationsController', organizationsController)
  .component('stOrganizationsList', stOrganizationsList)
  .controller('organizationSuspendedController', organizationSuspendedController)
  .controller('organizationSwitchController', organizationSwitchController)
  .service(
    'organizationService',
    ($http, dataService, Organization, ORGANIZATION, BILLING) => ({
      createOrganization: (doc) => dataService.createDocument(Organization, doc),
      readOrganization: (doc) => dataService.readDocument(Organization, doc),
      updateOrganization: (doc) => dataService.updateDocument(Organization, doc),
      deleteOrganization: (doc) => dataService.deleteDocument(Organization, doc),
      cloneOrganization: (params) =>
        dataService.apiRequest(
          null,
          null,
          true,
          Organization.build,
          $http.post,
          ORGANIZATION.API.CLONE,
          {
            params
          }
        ),
      moveGoB: (params) =>
        dataService.apiRequest(null, null, true, null, $http.get, ORGANIZATION.API.MOVE_GOB, {
          params
        }),
      phoneEnable: () =>
        dataService.apiRequest(
          null,
          null,
          true,
          null,
          $http.post,
          ORGANIZATION.API.PHONE_ENABLE,
          {}
        ),
      phoneList: (params) =>
        dataService.apiRequest(null, null, true, null, $http.get, ORGANIZATION.API.PHONE_LIST, {
          params
        }),
      phoneRent: (params) =>
        dataService.apiRequest(
          null,
          null,
          true,
          null,
          $http.post,
          ORGANIZATION.API.PHONE_RENT,
          {
            params
          },
          null,
          true
        ),
      phoneSearch: (params) =>
        dataService.apiRequest(
          null,
          null,
          true,
          null,
          $http.get,
          ORGANIZATION.API.PHONE_SEARCH,
          {
            params
          }
        ),
      phoneUnrent: (params) =>
        dataService.apiRequest(
          null,
          null,
          true,
          null,
          $http.post,
          ORGANIZATION.API.PHONE_UNRENT,
          {
            params
          },
          null,
          true
        ),
      resetApiKey: (params) =>
        dataService.apiRequest(
          null,
          null,
          true,
          null,
          $http.post,
          ORGANIZATION.API.RESET_API_KEY,
          {
            params
          }
        ),
      isUrlAvailable: (params) =>
        dataService.apiRequest(
          null,
          null,
          true,
          null,
          $http.get,
          ORGANIZATION.API.IS_URL_AVAILABLE,
          {
            params
          }
        )
    })
  )
  .service('organizationHelperService', (BILLING) => ({
    getSubscription: (org, sub) =>
      _.find(org.subscription?.subscriptions?.data, (obj) => obj?.plan?.id === sub)
  }))
  .service(
    'organizationsService',
    ($http, $rootScope, CacheFactory, dataService, Organization, ORGANIZATION) => {
      let cache;
      if (!CacheFactory.get(ORGANIZATION.CACHE.NAME)) {
        cache = CacheFactory(ORGANIZATION.CACHE.NAME, ORGANIZATION.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || ORGANIZATION.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailableGoB: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getAvailableGoB'),
            params?.ignoreCache === true,
            Organization.build,
            $http.get,
            ORGANIZATION.API.AVAILABLE_GOB,
            { params }
          ),
        getGroup: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey($rootScope.CurrentOrganization.id, 'getGroup'),
            params?.ignoreCache === true,
            Organization.build,
            $http.get,
            ORGANIZATION.API.GROUP,
            {}
          ),
        getRoot: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey($rootScope.CurrentOrganization.id, 'getRoot'),
            params?.ignoreCache === true,
            Organization.build,
            $http.get,
            ORGANIZATION.API.ROOT,
            {}
          )
      };
    }
  )
  .constant('ORGANIZATION', {
    API: {
      AVAILABLE: '/api/v1/organizations/available/',
      AVAILABLE_GOB: '/api/v1/organizations/available-groups-and-branches/',
      CLONE: '/api/v1/organization/clone/',
      SPECIFIC: '/api/v1/organizations/specific/',
      UPLOAD: '/api/v1/organization/logo-upload/',
      UPLOAD_GOB: '/api/v1/organization/logo-upload-groups-and-branches/',
      MOVE_GOB: '/api/v1/organization/move-groups-and-branches/',
      IS_URL_AVAILABLE: '/api/v1/organization/is-url-available/',
      PHONE_ENABLE: '/api/v1/organization/phone-enable/',
      PHONE_LIST: '/api/v1/organization/phone-list/',
      PHONE_RENT: '/api/v1/organization/phone-rent/',
      PHONE_SEARCH: '/api/v1/organization/phone-search/',
      PHONE_UNRENT: '/api/v1/organization/phone-unrent/',
      GROUP: '/api/v1/organization/group/',
      ROOT: '/api/v1/organization/root/',
      RESET_API_KEY: '/api/v1/organization/reset-api-key/'
    },
    LIMITS: {
      MULTIPLE: false,
      ALLOWED_MIME: 'image/*',
      ALLOWED_EXTENSIONS: '.jpeg,.jpg,.png',
      CROP_TYPE: 'rectangle',
      ASPECT_RATIO: '6',
      MIN_WIDTH: '480',
      MIN_HEIGHT: '80'
    },
    FIELDS: {
      LIST: {
        list: [
          'id',
          'idRoot',
          'idParent',
          'idOwner',
          'idBrokers',
          'idManagers',
          'externalReferenceId',
          'organization'
        ]
      }
    },
    SETTINGS: {
      CLIENT_PORTAL: {
        CLIENT_PROFILE_WIZARD: [
          { id: 1, name: 'Your details' },
          { id: 2, name: 'Employment' },
          { id: 3, name: 'Income' },
          { id: 4, name: 'Expenses' },
          { id: 5, name: 'Real estate' },
          { id: 6, name: 'Other assets' },
          { id: 7, name: 'Liabilities' },
          { id: 8, name: 'Needs and objectives' },
          { id: 9, name: 'Product requirements' }
        ]
      }
    },
    CACHE: {
      NAME: 'organizationsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
